<template>
  <a-select v-model:value="valueList" :class="newDataStatus ? 'inp' : 'inp ml16'" :options="options" mode="multiple"
    :max-tag-count="2" placeholder="请选择">
    <template #dropdownRender="{ menuNode: menu }">
      <v-nodes :vnodes="menu" />
      <a-divider style="margin: 4px 0" />
      <a-space style="padding: 4px 8px">
        <a-checkbox v-model:checked="allChecked" @change="changeAll"> 全选</a-checkbox>
      </a-space>
    </template>

  </a-select>
</template>

<script setup>
import { ref, reactive, defineComponent, watch, watchEffect, nextTick, defineExpose } from 'vue'

const props = defineProps({
  //默认选中的值
  oldValue: {
    type: Object,
  },
  //请求下拉框里面的值 option，与list只能二选一
  myAjax: {
    type: Function,
  },
  //请求所需要的参数
  query: {
    type: Object,
    default: () => {
      return {}
    }
  },
  //下拉框里面的值 option ，与myAjax只能二选一
  list: {
    type: Array,
    // default:[]
  },
  // 阶段性报告 数据结构不一样 需要区分
  newDataStatus: {
    type: Boolean,
    default: false
  }
})

const valueList = ref([]);//值
const labelList = ref([]);//对应的label
const options = ref([]);
const allChecked = ref(false)

const changeAll = (e) => {
  let checked = e.target.checked;
  allChecked.value = checked;
  console.log(checked)
  let arr = []
  if (checked) {
    options.value.forEach(item => {
      arr.push(item.value)
    })
    valueList.value = checked ? arr : []
  }
  // console.log(valueList.value);
}


watch(valueList, (val) => {
  console.log(22, options.value, props.query)
  if (valueList.value && options.value && valueList.value.length == options.value.length && valueList.value.length) {
    allChecked.value = true;
  } else {
    allChecked.value = false;
  }
  labelList.value = [];
  console.log(allChecked.value);
  valueList.value?.map(item => {
    options.value?.map(p => {
      console.log(item, p.value)
      if (item == p.value) {
          labelList.value.push(p.label)
        }

    })

  })
  console.log(labelList.value, 'labelList', valueList.value, val)
})


//父组件传递过来的下拉选项
watchEffect(() => {

  //   valueList.value = [];
  console.log(props.list, 2222222233)
  options.value = props.list?.map(item => ({ label: item.name, value: item.id }));
}, { deep: true, immediate: true });

watchEffect(() => {
  valueList.value = props.oldValue
}, { deep: true, immediate: true });


const getSafety = () => {
  props.myAjax({ ...props.query }).then(res => {
    if (props.newDataStatus) {
      res.data.records.map(item => {
        item.value = item.id;
        item.label = item.testCarNum;
      });
      options.value = res.data.records;
    } else {

      res.data.map(item => {
        item.value = item.id;
        item.label = item.name;
      });
      options.value = res.data;
    }
  })
};
const VNodes = defineComponent({
  props: {
    vnodes: {
      type: Object,
      required: true,
    },
  },
  render() {
    return this.vnodes;
  },
});

if (!props.myAjax && props.list) {
  //存在数据，直接渲染
} else {
  //不存在数据，主动请求
  getSafety();
}

defineExpose({
  valueList,
  labelList
})



</script>